import ro from "./lang/ro.js";
import at from "./lang/at.js";
import de from "./lang/de.js";
import fr from "./lang/fr.js";
import hu from "./lang/hu.js";
// import en from "@/translations/productie/proforma/lang/en.js";

export const languages = {
    ro: ro,
    at: at,
    de: de,
    fr: fr,
    hu: hu,
    // en: en
}